import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss']
})
export class LocationListComponent extends BaseList implements OnInit {

  public locations: Array<LocationModel> = [];
  public apiUrl = '/locations';

  protected rightLoad = 'admin.location.list';
  protected rightNew = 'admin.location.create';
  protected rightOpen = 'admin.location.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.locations'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('locations').subscribe({
      next: (locations: any) => {
        this.locations = [];
        locations.data.forEach((location: any) => {
          this.locations.push(new LocationModel().deserialize(location));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
